import _ from 'lodash'
import { useMemo, useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'

import PageContainer from '@/components/ui/containers/PageContainer'
import TabPanel from '@/components/ui/tab/TabPanel'

import { ConsultationReasons } from './ui/ConsultationReasons'
import { SpecialityOptions } from './ui/SpecialityOptions'
import { ConsultationSettings } from './ui/ConsultationSettings'

export function SettingsPage() {
  useLingui()

  const [tabValue, setTabValue] = useState(0)

  const tabs = useMemo(
    () => [
      { id: 'specialityOption', label: t`Speciality options` },
      { id: 'consultationReason', label: t`Consultation reasons` },
      { id: 'consultationSettings', label: t`Consultation settings` },
    ],
    []
  )

  const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box>
      <Container maxWidth="xl" sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Stack spacing={1} sx={{ pl: '30px', pr: '30px' }}>
          <Typography variant="h2" sx={{ mt: '30px', mb: '30px' }}>
            <Trans>Super admin settings</Trans>
          </Typography>
          <Tabs value={tabValue} onChange={handleChangeTab}>
            {_.map(tabs, (tab) => (
              <Tab key={tab.id} label={tab.label} />
            ))}
          </Tabs>
        </Stack>
      </Container>
      <PageContainer>
        <TabPanel value={tabValue} index={0}>
          <SpecialityOptions />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <ConsultationReasons />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <ConsultationSettings />
        </TabPanel>
      </PageContainer>
    </Box>
  )
}

export default SettingsPage
